// 简体中文
// import zhCNLocale from 'element-ui/lib/locale/lang/zh-CN'
// import {deepObjectMerge} from '../../utils/index.js'
const lang = {
  login: {
    user: '用户名',
    account: '账号',
    password: '密码',
    signin: '登录',
    signtitle: '用户登录',
    forgetpassword: '忘记密码',
    regsiter: '开发者注册',
    accountLogin: '使用账号登录',
    codeTips: '校验码短信已发送，有效时间为30分钟，请及时查收。'
  },

  common: {
    retrieveAfterSeconds: ' 秒',
    getVerificationCode: '获取验证码',
    uploadCompanyLogo: '上传头像图片支持JPG、PNG格式!',
    uploadCompanyLogoSize: '上传头像图片大小不能超过2MB!',
    uploadAvaterTips: '头像支持JPG、PNG格式，且大小不超过2M',
    uploadSuccess: '上传成功',
    uploadFail: '上传失败',
    i18nKey: 'i18nKey',
    i18nKeyRequire: '请输入i18nKey',
    sys: '厦门熵基科技快速开发平台前端框架',
    add: '新增',
    search: '搜索',
    edit: '编辑',
    release: '发布',
    update: '修改',
    delete: '删除',
    cancel: '取 消',
    confirm: '确 定',
    selectDate: '选择日期',
    select: '请选择',
    success: '成功',
    fail: '失败',
    remark: '备注',
    status: '状态',
    name: '名称',
    statusRequire: '请选择状态',
    remarkRequire: '请输入备注',
    nameRequire: '请输入名称',
    confirmDelete: '确认删除？',
    successDelete: '删除成功',
    cancelDelete: '已取消删除',
    addUser: '添加用户',
    addSuccess: '添加成功',
    inputUserName: '请输入用户名',
    sourceList: '源列表',
    targetList: '目的列表',
    addUserSuccess: '添加用户成功',
    selectUser: '请先选择用户后，再进行操作',
    confirmDeleteUserTip: '您确定删除选中的用户？',
    startTime: '开始时间',
    startTimePla: '请输入开始时间',
    endTime: '结束时间',
    endTimePla: '请输入结束时间',
    userNamePla: '请输入账号',
    logNamePla: '请输入日志名称',
    logType: '日志类型',
    select1record: '请点击表格选中记录!',
    confirmDeleteRecordTip: '您确定删除选中的记录？',
    operation: '操作',
    errorNotice: '错误提示',
    warningNotice: '温馨提示'
  },
  user: {
    accountByLogin: '登录账号',
    dbsPrivacy: '《Smart DBS隐私权政策》',
    agree: '我同意',
    useEmailReg: '使用邮箱注册',
    usePhoneReg: '使用手机注册',
    pwdStrength: '密码强度',
    week: '弱',
    middle: '中',
    hight: '高',
    noConfirmedPwd: '确认密码不能为空',
    emailCodeError: '输入的验证码不正确，请重新再试',
    sureEmailTip: '请输入正确邮箱',
    onceLogin: '立即登录',
    baseInfo: '基本信息',
    activation: '点击获取',
    userNameTips: '请填写未被熵基科技设备平台注册的用户名',
    emailTips: '请填写未被熵基科技设备平台注册的邮箱',
    emailCode: '验证码',
    inputEmailCode: '请输入验证码',
    emailCodeTips: '点击获取验证码后将收到验证邮件，请回填邮件中的6位验证码',
    inputPwdTips: '密码必须包含数字和字母,且长度在8到16位密码之间',
    services: '《第三方开发者服务协议》',
    regsiter: '注册',
    hasAcount: '已有开发者帐号？',
    startTime: '注册开始时间',
    endTime: '注册结束时间',
    superAdmin: '超级管理员',
    account: '账号',
    status: '状态',
    userName: '用户名称',
    password: '密码',
    confirmedPwd: '确认密码',
    email: '邮箱',
    phone: '手机',
    sex: '性别',
    nickName: '昵称',
    department: '部门',
    role: '角色',
    roleManagement: '角色管理',
    registerTime: '注册时间',
    inputAccount: '请输入账号/手机号/邮箱',
    inputForgetName: '请输入账号',
    inputName: '请输入姓名',
    inputPwd: '请设置密码',
    inputPwd2: '请输入密码',
    input2ndPwd: '请再次输入密码',
    pwdInconsistent: '两次密码输入不一样',
    inputEmail: '请输入邮箱',
    inputPhone: '请输入手机',
    inputNickName: '请输入昵称',
    selectStatus: '请选择状态',
    addUser: '新增用户',
    modifyUser: '修改用户',
    userDetail: '用户详情',
    select1record: '请点击表格选中一条记录！',
    notAllowToChange: '超级管理员不允许修改！',
    notAllowToRemove: '超级管理员不允许删除！',
    notAllowToResetPwd: '超级管理员不允许重置密码！',
    notAllowToFreeze: '超级管理员不允许冻结！',
    confirmDelete: '确认删除？',
    deleteUser: '删除用户',
    confirmDeleteTip: '您确定要删除账号为：| 的用户吗？',
    confirmResetPwd: '重置密码',
    confirmResetPwdTip: '您确定要将账号为：| 的用户密码重置为12345678吗？',
    successResetPwd: '重置密码成功',
    cancelResetPwd: '取消重置密码',
    confirmFreeze: '冻结用户',
    confirmFreezeTip: '您确定要将账号为：| 的用户冻结吗?',
    successFreeze: '冻结用户成功',
    cancelFreeze: '取消冻结用户',
    notNeedUnfreeze: '当前用户已启用，无需解除冻结',
    confirmUnfreeze: '解除冻结',
    confirmUnfreezeTip: '您确定要将账号为：| 的用户解除冻结吗?',
    successUnfreeze: '解除冻结用户成功',
    cancelUnfreeze: '取消解除冻结用户',
    roleAllot: '角色分配'
  },
  department: {
    addDept: '新增部门',
    updateDept: '编辑部门',
    parentDept: '父级部门',
    deptName: '部门名称',
    deptStatus: '部门状态',
    nameRequire: '请输入部门名称',
    notDeleteRoot: '根部门不允许删除！',
    notDeleteDept: '此部门含有子部门，不能删除！',
    confirmDeleteDeptTip: '您确定删除此部门？',
    selectDept: '请先选择部门后，再进行操作'
  },
  area: {
    addArea: '新增区域',
    updateArea: '编辑区域',
    parentArea: '父级区域',
    areaName: '区域名称',
    areaStatus: '区域状态',
    nameRequire: '请输入区域名称',
    notDeleteRoot: '根区域不允许删除！',
    notDeleteArea: '此区域含有子区域，不能删除！',
    confirmDeleteAreaTip: '您确定删除此区域？',
    selectArea: '请先选择区域后，再进行操作'
  },
  resource: {
    resourceName: '资源名称',
    sortNo: '排序',
    resourceEvent: '按钮事件',
    resourceType: '类型',
    notDeleteRoot: '不允许删除根资源',
    notUpdateRoot: '不允许修改根资源',
    addResource: '添加资源',
    updateResource: '更新资源',
    confirmDeleteTip: '您确定要删除资源：',
    icon: '图标',
    routerName: '路由名称',
    btnGroup: '组名',
    urlRequire: '请输入URL',
    routerNameRule: '与开发配置路由名称相同',
    btnGroupRequire: '请输入按钮组名称',
    btnTypeRequire: '请选择按钮类型',
    btnStyleRequire: '请选择按钮样式',
    btnType: '按钮类型',
    btnStyle: '按钮样式',
    btnEffect: '按钮效果',
    parentResource: '父级资源',
    default: '默认按钮',
    primary: '主要按钮',
    success: '成功按钮',
    text: '文本',
    info: '信息按钮',
    warning: '警告按钮',
    danger: '危险按钮',
    plain: '朴素按钮',
    round: '圆角按钮',
    circle: '圆形按钮',
    typeRequire: '请选择资源类型',
    sortNoRequire: '请输入序号',
    intRequire: '请输入正整数',
    parentRequire: '请选择父级资源',
    parentRule1: '父级资源不允许是资源自身',
    parentRule2: '父级资源不允许是本资源的子级资源',
    resourceEventRequire: '请输入按钮事件',
    disabled: '禁用'
  },
  role: {
    addRole: '添加角色',
    addRoleGroup: '添加角色组',
    role: '角色',
    addRoleSuccess: '角色新增成功',
    updateRoleSuccess: '角色修改成功',
    roleGroup: '角色组',
    roleName: '角色名称',
    roleGroupName: '角色组名称',
    roleGroupNameRequire: '请输入角色组名称',
    roleGroupRequire: '请选择角色组',
    roleNameRequire: '请输入角色名称',
    noGroup: '暂不分组',
    confirmDeleteTip: '您确认要删除此用户角色?',
    confirmDeleteGroupTip: '您确认要删除此用户角色组?',
    addUser: '添加成员',
    authorization: '授权',
    authorizeSuccess: '授权成功',
    authorizeFail: '授权失败',
    selectRoleToAddUserTip: '请在左侧选择需要添加用户的角色',
    selectRoleToAuthorizeTip: '请在左侧选择授权的角色',
    selectUser: '请选择用户',
    confirmDeleteUserTip: '您确认要移除:|的用户角色',
    notDeleteAdmin: '超级管理员下的admin用户不允许删除！'
  },
  param: {
    paramType: '参数类型',
    paramName: '参数名称',
    paramValue: '参数值',
    sortNo: '排序值',
    paramStatus: '参数状态',
    addParam: '新增系统参数',
    updateParam: '修改系统参数',
    confirmDeleteTip: '您确定删除此系统参数？',
    typeRequire: '请输入系统参数类型',
    nameRequire: '请输入参数名称',
    valueRequire: '请输入系统参数值'
  },
  dictionary: {
    name: '名称',
    type: '类型',
    dictName: '字典名称',
    dictType: '字典类型',
    value: '字典值',
    sortNo: '排序值',
    addDict: '新增字典',
    updateDict: '修改字典',
    confirmDeleteTip: '您确定删除此数据字典？',
    nameRequire: '请输入字典名称',
    typeRequire: '请输入字典类型',
    valueRequire: '请输入字典值',
    sortNoRequire: '请输入排序值'
  },
  announcement: {
    id: '#',
    title: '标题',
    content: '公告内容',
    validDate: '有效时间',
    modifiedDate: '修改时间',
    modifiedBy: '修改者',
    createdDate: '发布时间',
    createdBy: '创建者',
    addDict: '新增公告',
    updateDict: '修改公告',
    beginTime: '开始',
    endTime: '结束',
    effectTime: '开始',
    expirationTime: '结束',
    addAnnouncement: '添加公告',
    deleteSure: '您确定要删除该条公告？',
    modifyAnnouncemnet: '修改公告',
    choiceTime: '选择日期时间',
    announcementStatus: '是否发布',
    inputTitle: '请输入标题',
    inputContent: '请输入内容',
    inputTime: '请输入时间',
    titleMaxLength: '最大长度为50',
    contentMaxLength: '最大长度为500',
    nameMaxLength: '最大长度为30',
    announcementDetal: '公告详情',
    status: '状态',
    annRelease: '已发布',
    annNotRelease: '未发布',
    releaseSuccess: '发布成功',
    releaseFail: '发布失败'
  },
  advice: {
    id: '#',
    advice: '建议内容',
    reply: '回复内容',
    replyBy: '回复者',
    replyDate: '回复时间',
    status: '回复状态',
    createdDate: '创建时间',
    createdBy: '创建者',
    createTime: '创建时间',
    beginTime: '创建时间',
    endTime: '结束时间',
    replayStatus: '回复状态',
    replied: '已回复',
    noReply: '未回复',
    all: '全部',
    replayBtn: '回复',
    deleteBtn: '删除',
    addAdvice: '我要反馈',
    adviceContent: '建议内容',
    adviceReplay: '建议回复',
    advContent: '建议内容',
    replayContent: '回复内容',
    deleteSure: '确认删除这条建议吗？'
  },
  loginLog: {
    loginLog: '登录日志',
    loginFailLog: '登录失败日志',
    exitLog: '退出日志',
    account: '账号',
    time: '时间',
    details: '详情'
  },
  operatorLog: {
    logName: '日志名称',
    operatorLog: '操作日志',
    exceptionLog: '异常日志',
    account: '账号',
    className: '操作类名',
    methodName: '操作方法',
    msg: '具体消息',
    result: '操作结果',
    costTime: '耗时(ms)',
    time: '时间'
  },
  account: {
    accountInfo: '账号信息',
    modifyPwd: '修改密码',
    loginOut: '退出登录',
    account: '账号',
    oldPwd: '原密码',
    newPwd: '新密码',
    confirmNewPwd: '确认新密码',
    oldPwdRequire: '请输入原密码',
    newPwdRequire: '请输入新密码',
    confirmNewPwdRequire: '请再次输入新密码',
    newEqualOld: '新密码与原密码一样',
    newNotEqualNew: '两次密码输入不一样',
    modifyPwdSuccess: '修改密码成功！',
    newPasswordLength: '长度必须在8到16位密码之间',
    mustContain: '必须包含数字和字母'
  },
  dstConfig: {
    colHeaderTip: '如果结束年份为N/A,则表示永久有效',
    dstName: '名称',
    timezone: '时区',
    startTime: '开始时间',
    endTime: '结束时间',
    startYear: '开始年份',
    endYear: '结束年份',
    dstNameRequire: '请输入夏令时名称',
    timezoneRequire: '请输入时区',
    startTimeRequire: '请输入开始时间',
    endTimeRequire: '请输入结束时间',
    startYearRequire: '请输入开始年份',
    endYearRequire: '请输入结束年份',
    active: '状态',
    addDstConfig: '新增夏令时配置',
    updateDstConfig: '修改夏令时配置',
    confirmDeleteTip: '您确定删除此夏令时规则？',
    startTimeDesc:
      '格式为：MMIIWWHH, MM:月, II:第几个星期(01:表示第一个星期, 02:表示第二个星期, 03:表示第三个星期, 04:表示第四个星期, 11:表示倒数第一个星期), WW:星期, HH:小时',
    endTimeDesc: '为空时，则表示永久有效'
  }
}
export default lang // deepObjectMerge(lang, zhCNLocale)



// WEBPACK FOOTER //
// ./src/cdpBase/i18n/lang/zh_cn.js